function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import PhoneNumber from "awesome-phonenumber";
import allCountries from "./countries";

function getCountryByIp() {
  return fetch("https://ip2c.org/s").then(function (response) {
    return response.text();
  }).then(function (response) {
    var result = (response || "").toString();

    if (!result || result[0] !== "1") {
      throw new Error("unable to fetch the country");
    }

    return result.substr(2, 2);
  });
}

export default {
  props: {
    spec: {
      type: Object,
      required: true
    },
    rules: {
      type: Array,
      "default": function _default() {
        return [function (v) {
          return !v || /^\+[1-9]([0-9\(\)\-\ ]*)$/.test(v) || "Must be a valid international phone number with prefix (e.g. +1 416 555 0134)";
        }];
      }
    },
    disableFetchingCountry: {
      type: Boolean,
      "default": function _default() {
        return false;
      }
    },
    mode: {
      type: String,
      "default": function _default() {
        return "";
      }
    },
    allCountries: {
      type: Array,
      "default": function _default() {
        return allCountries;
      }
    },
    preferredCountries: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    inputId: {
      type: String,
      "default": function _default() {
        return "";
      }
    }
  },
  data: function data() {
    return {
      phone: "",
      activeCountry: {
        iso2: ""
      },
      selectedIndex: null,
      countryCode: null
    };
  },
  computed: {
    parsedMode: function parsedMode() {
      if (this.mode) {
        if (!["international", "national"].includes(this.mode)) {
          console.error('Invalid value of prop "mode"');
        } else {
          return this.mode;
        }
      }

      if (!this.phone || this.phone[0] !== "+") {
        return "national";
      }

      return "international";
    },
    sortedCountries: function sortedCountries() {
      // Sort by preferred countries
      var preferredCountries = this.getCountries(this.preferredCountries).map(function (country) {
        return _objectSpread(_objectSpread({}, country), {}, {
          preferred: true
        });
      });
      return [].concat(_toConsumableArray(preferredCountries), _toConsumableArray(this.allCountries));
    },
    phoneObject: function phoneObject() {
      var result = PhoneNumber(this.phone || "", this.activeCountry.iso2).toJSON();
      Object.assign(result, {
        isValid: result.valid,
        country: this.activeCountry
      });

      if (!this.phone) {
        return _objectSpread(_objectSpread({}, result), {}, {
          number: {
            input: ""
          }
        });
      }

      return result;
    },
    phoneText: function phoneText() {
      var key = "input";

      if (this.phoneObject.valid) {
        key = this.parsedMode;
      }

      return this.phoneObject.number[key] || "";
    }
  },
  watch: {
    phone: function phone(val) {
      if (val) {
        if (val[0] === "+") {
          var code = PhoneNumber(val).getRegionCode();

          if (code) {
            this.activeCountry = this.findCountry(code) || this.activeCountry;
          }
        }
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.initializeCountry().then(function () {
      if (!_this.phone && _this.activeCountry.dialCode) {
        _this.phone = "+".concat(_this.activeCountry.dialCode);
      }

      _this.countryCode = _this.activeCountry;
    })["catch"](console.error);
  },
  created: function created() {
    if (this.spec.value) {
      this.phone = this.spec.value.trim();
    }
  },
  methods: {
    hiddenDisplay: function hiddenDisplay() {
      return this.$styles()["display"] == "none";
    },
    classes: function classes() {
      return this.$classes().concat(["g-text-field--hintless", "fields-phone"]);
    },
    initializeCountry: function initializeCountry() {
      var _this2 = this;

      return new Promise(function (resolve) {
        // 1. If the phone included prefix (+12), try to get the country and set it
        if (_this2.phone && _this2.phone[0] === "+") {
          var activeCountry = PhoneNumber(_this2.phone).getRegionCode();

          if (activeCountry) {
            _this2.choose(activeCountry);

            resolve();
            return;
          }
        } // 2. Use default country if passed from parent


        if (_this2.spec.defaultCountry) {
          var defaultCountry = _this2.findCountry(_this2.spec.defaultCountry);

          if (defaultCountry) {
            _this2.choose(defaultCountry);

            resolve();
            return;
          }
        }

        var fallbackCountry = _this2.findCountry(_this2.preferredCountries[0]) || _this2.allCountries[0]; // 3. Check if fetching country based on user's IP is allowed, set it as the default country


        if (!_this2.disableFetchingCountry) {
          getCountryByIp().then(function (res) {
            if (_this2.phone === "") {
              _this2.activeCountry = _this2.findCountry(res) || _this2.activeCountry;
            }
          })["catch"](function (error) {
            console.warn(error); // 4. Use the first country from preferred list (if available) or all countries list

            _this2.choose(fallbackCountry);
          })["finally"](function () {
            resolve();
          });
        } else {
          // 4. Use the first country from preferred list (if available) or all countries list
          _this2.choose(fallbackCountry);

          resolve();
        }
      });
    },
    // Get ISO2 code from a list of countries
    getCountries: function getCountries() {
      var _this3 = this;

      var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return list.map(function (countryCode) {
        return _this3.findCountry(countryCode);
      }).filter(Boolean);
    },
    findCountry: function findCountry() {
      var iso = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
      return this.allCountries.find(function (country) {
        return country.iso2 === iso.toUpperCase();
      });
    },
    getItemClass: function getItemClass(index, iso2) {
      var highlighted = this.selectedIndex === index;
      var lastPreferred = index === this.preferredCountries.length - 1;
      var preferred = this.preferredCountries.some(function (c) {
        return c.toUpperCase() === iso2;
      });
      return {
        highlighted: highlighted,
        "last-preferred": lastPreferred,
        preferred: preferred
      };
    },
    choose: function choose(country) {
      this.activeCountry = country || this.activeCountry || {};

      if (this.phone && this.phone[0] === "+" && this.activeCountry.iso2 && this.phoneObject.number.significant) {
        // If country is selected & the field has a valid international phone number
        this.phone = PhoneNumber(this.phoneObject.number.significant, this.activeCountry.iso2).getNumber("international");
      } else if (country && this.phone && (!this.phoneObject.number.significant || this.phone[0] !== "+")) {
        // If a new country is selected & the field has NO valid international phone number
        this.phone = "+".concat(country.dialCode);
      } else if (country && !this.phone) {
        // If a new country is selected & the field has NO value
        this.phone = "+".concat(country.dialCode);
      }
    },
    reset: function reset() {
      this.selectedIndex = this.sortedCountries.map(function (c) {
        return c.iso2;
      }).indexOf(this.activeCountry.iso2);
    },
    onChangeCountryCode: function onChangeCountryCode() {
      this.choose(this.countryCode, true);
    }
  }
};